module.exports = "\r\n  <div class=\"modal-header\">\r\n \r\n     <div class=\"head_top_inner\">\r\n        <headerMenu></headerMenu>\r\n\r\n    </div>\r\n  </div>\r\n \r\n  <div class=\"modal-body\">\r\n\r\n    <!-- <alert></alert> -->\r\n\r\n     <!-- Exchange Componet -->\r\n         <app-dashboard-exchangerate></app-dashboard-exchangerate>\r\n  </div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/exchange-rate/exchange-rate.component.html
// module id = ./src/app/exchange-rate/exchange-rate.component.html
// module chunks = main